export default __webpack_public_path__ + "static/media/4.a7048838.jpg";